
import { Pill, Droplet, Syringe } from 'lucide-react';
import { Medication } from './index';

export const additionalMedications: Medication[] = [
  {
    id: '38',
    name: 'Finasteride',
    description: 'A 5-alpha-reductase inhibitor that reduces DHT levels, used for hair loss and prostate health in men.',
    research: 'Finasteride for Hair Loss - Finasteride reduces DHT, slowing hair loss in 85% of men with androgenetic alopecia after 1 year. It also shrinks prostate size in BPH.',
    url: 'https://www.jaad.org/article/S0190-9622(98)70007-6/fulltext',
    category: 'additional',
    Icon: Pill,
    video: 'https://www.youtube.com/watch?v=2h2KxYfGJzY',
    availablePreparations: 'Oral Tablets (e.g., 1 mg, 5 mg; with Minoxidil at 1 mg/2.5 mg)',
    clinicalDetails: {
      dosingGuidelines: '1 mg PO daily (hair loss); 5 mg PO daily (BPH).',
      administrationProtocols: 'Oral, with or without food.',
      contraindications: 'Pregnancy (teratogenic), hypersensitivity, liver disease.',
      monitoringRequirements: 'Monitor PSA, hair growth, sexual function; assess for depression, libido changes.'
    },
    adverseReactions: {
      common: 'Decreased libido, erectile dysfunction, ejaculation disorders.',
      lessCommon: 'Breast tenderness, depression.',
      rare: 'Breast cancer, high-grade prostate cancer.'
    }
  },
  {
    id: '39',
    name: 'Minoxidil',
    description: 'A vasodilator that promotes hair growth when compounded or applied topically, often used with Finasteride.',
    research: 'Minoxidil for Hair Growth - Minoxidil, a vasodilator, promotes hair regrowth in 60-70% of alopecia patients via topical or oral use, extending anagen phase of hair follicles.',
    url: 'https://onlinelibrary.wiley.com/doi/abs/10.1111/j.1365-2133.1987.tb05825.x',
    category: 'additional',
    Icon: Droplet,
    video: 'https://www.youtube.com/watch?v=2h2KxYfGJzY',
    availablePreparations: 'Topical Solution (e.g., 2-5%), Oral Capsules (e.g., 2.5 mg with Finasteride)',
    clinicalDetails: {
      dosingGuidelines: 'Topical: 2-5% twice daily; Oral: 2.5-5 mg PO daily (off-label compounded).',
      administrationProtocols: 'Topical: Apply to scalp, avoid eyes. Oral: With or without food.',
      contraindications: 'Hypersensitivity, pheochromocytoma (oral), scalp infection (topical).',
      monitoringRequirements: 'Monitor hair growth, BP (oral), scalp irritation (topical).'
    },
    adverseReactions: {
      common: 'Scalp irritation, unwanted hair growth (topical); Hypotension, tachycardia (oral).',
      lessCommon: 'Dizziness, fluid retention (oral); Allergic dermatitis (topical).',
      rare: 'Pericardial effusion, allergic reactions.'
    }
  },
  {
    id: '42',
    name: 'Low-dose Naltrexone',
    description: 'An opioid antagonist used in low doses to modulate immune function and reduce inflammation, with emerging use in weight management.',
    research: 'LDN in Inflammation - Low-dose Naltrexone (1-4.5 mg) reduces inflammation and pain in chronic conditions by modulating endorphins. Small trials show 30-50% symptom relief.',
    url: 'https://translational-medicine.biomedcentral.com/articles/10.1186/s12967-014-0266-3',
    category: 'additional',
    Icon: Pill,
    availablePreparations: 'Oral Capsules (e.g., 1-3 mg)',
    clinicalDetails: {
      dosingGuidelines: '1.5-4.5 mg PO nightly (off-label; compounded).',
      administrationProtocols: 'Oral, at bedtime to minimize side effects.',
      contraindications: 'Opioid use, hypersensitivity, acute liver failure.',
      monitoringRequirements: 'Monitor pain, inflammation; assess liver function, sleep disturbances.'
    },
    adverseReactions: {
      common: 'Insomnia, vivid dreams, headache.',
      lessCommon: 'Nausea, dizziness.',
      rare: 'Liver enzyme elevation, allergic reactions.'
    }
  },
  {
    id: '50',
    name: 'Dexpanthenol (Vitamin B5)',
    description: 'A vitamin B5 derivative that supports tissue repair and metabolism, used in injectable form.',
    research: 'Dexpanthenol in Healing - Dexpanthenol, a B5 analog, speeds wound healing by 20-30% via coenzyme A synthesis. Injectable forms enhance tissue repair in clinical settings.',
    url: 'https://www.karger.com/Article/Abstract/211505',
    category: 'additional',
    Icon: Syringe,
    availablePreparations: 'Injection (e.g., 250 mg/ml; in B Complex, ICB Complex)',
    clinicalDetails: {
      dosingGuidelines: '250-500 mg IM/IV daily or weekly (compounded).',
      administrationProtocols: 'IM or IV injection/infusion; dilute IV in saline.',
      contraindications: 'Hypersensitivity; caution in hemophilia (limited data).',
      monitoringRequirements: 'Monitor wound healing, energy; assess injection reactions.'
    },
    adverseReactions: {
      common: 'Injection site reactions, diarrhea.',
      lessCommon: 'Itching, rash.',
      rare: 'Allergic reactions, hypotension.'
    }
  },
  {
    id: '56',
    name: 'SLIM BOOST',
    description: 'A potent lipotropic injection with added vitamins and amino acids to enhance fat loss, energy, and metabolism.',
    research: 'Lipotropic Enhancements - SLIM BOOST amplifies fat loss and energy with added B vitamins and L-Carnitine, showing 10-15% greater weight reduction than MIC in pilot studies.',
    url: 'https://www.sciencedirect.com/science/article/abs/pii/S1871-403X17301347',
    category: 'additional',
    Icon: Syringe,
    availablePreparations: 'Injection (e.g., 30 ml)',
    clinicalDetails: {
      dosingGuidelines: '1-2 mL IM weekly (e.g., 25/50/50/100/25/25/10 mg/mL; compounded).',
      administrationProtocols: 'IM injection in gluteal or deltoid; rotate sites.',
      contraindications: 'Hypersensitivity, severe liver/renal disease.',
      monitoringRequirements: 'Monitor weight, energy, liver function; assess injection reactions.'
    },
    adverseReactions: {
      common: 'Injection site reactions, nausea, diarrhea.',
      lessCommon: 'Headache, dizziness.',
      rare: 'Allergic reactions, vitamin toxicity.'
    }
  },
  {
    id: '57',
    name: 'Methylene Blue',
    description: 'A synthetic compound approved by the FDA to treat methemoglobinemia, a condition where hemoglobin can\'t deliver oxygen effectively. Originally developed as a dye, MB is also being studied off-label for neurodegenerative diseases, cognitive enhancement, and anti-aging due to its antioxidant and mitochondrial-supportive effects.',
    research: 'The Potentials of Methylene Blue as an Anti-Aging Drug - This review highlights MB\'s ability to enhance mitochondrial function, reduce oxidative stress, and support cellular energy production, making it promising for age-related conditions.',
    url: 'https://pmc.ncbi.nlm.nih.gov/articles/PMC8699482/',
    category: 'additional',
    Icon: Pill,
    video: 'https://www.youtube.com/watch?v=2h2KxYfGJzY',
    availablePreparations: 'Injection (e.g., 20 mg/ml), Oral Capsules (e.g., 30 mg)',
    clinicalDetails: {
      dosingGuidelines: 'Injection: 0.5-2 mg/kg IV slow infusion (methemoglobinemia). Oral: 0.5-1 mg/kg PO daily (off-label compounded).',
      administrationProtocols: 'IV over 5-10 min or oral; dilute IV in saline; avoid food interactions.',
      contraindications: 'G6PD deficiency, hypersensitivity, MAOI use (serotonin syndrome risk).',
      monitoringRequirements: 'Monitor methemoglobin (if indicated), cognition; assess for blue discoloration, serotonin syndrome.'
    },
    adverseReactions: {
      common: 'Blue discoloration (urine, skin), nausea, headache.',
      lessCommon: 'Hypertension, dizziness.',
      rare: 'Methemoglobinemia (high doses), serotonin syndrome.'
    }
  }
];
